<template>
    <div class="post">
        <LinkHover
            :type="'router-link'"
            :to="$trl({
                name: 'Technique',
                params: {
                    slug: post.customslug || post.slug,
                    locale: $route.params.locale
                }
            })"
            :class="['link-hover']"
        >
            <span class="caption">
                <span class="content">
                    {{ post.name }}
                </span>
            </span>
            <template v-slot:hover>
                <span class="caption hover">
                    <div class="bg-cross-animated"></div>
                    <span class="content">
                        {{ post.name }}
                    </span>
                </span>
            </template>
        </LinkHover>
    </div>
</template>
<script>
import LinkHover from '@/components/animation/LinkHover'
export default {
    components: {
        LinkHover
    },
    props: {
        post: {
            type: Object,
            default() {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.post
    flex: 1
    border: 1px solid #e0e1e3
    @include media-breakpoint-down($lg)
        border-top: 1px solid #e0e1e3
        border-right: 1px solid #e0e1e3
        border-left: 1px solid #e0e1e3
        border-bottom: none
    &:last-child
        border-right: 1px solid #e0e1e3
        @include media-breakpoint-down($lg)
            border-bottom: 1px solid #e0e1e3
.link-hover
    text-decoration: none
    display: block
.caption
    display: flex
    align-items: center
    width: 460px
    min-height: 420px
    padding-left: (100% * 90px / 510px)
    padding-right: (100% * 45px / 510px)
    @include media-breakpoint-down($lg)
        width: 100%
        min-height: auto
        // height: 80vw
        max-height: 420px
.content
    font-size: 50px
    color: #636772
    font-weight: 500
    line-height: 1.2
    min-height: 2.4em
    @include media-breakpoint-down($lg)
        min-height: auto
        padding: 16.25% 0
    @include media-breakpoint-down($sm)
        font-size: 25px
.hover
    background-color: #ff2b2a
    .content
        color: #ffffff
</style>
